import React, { useState } from 'react';
import styled from 'styled-components';
import { Redirect } from 'react-router-dom';
import { useAuthState } from 'react-firebase-hooks/auth';
import firebase from 'firebase/app';
import 'firebase/auth';

import { Notification } from '../../components/Notification';

const db = firebase.firestore();

export function SignUp() {
  const { user } = useAuthState(firebase.auth());
  const [value, setValue] = useState('');
  const [errors, setErrors] = useState('');

  const handleSubmit = async e => {
    const { email, password, passwordRepeat } = value;
    e.preventDefault();

    if (!value) {
      setErrors('Form must not be empty');

      setTimeout(() => {
        setErrors('');
      }, 5000);
      return;
    } else {
      setErrors('');
    }

    if (password !== passwordRepeat) {
      setErrors('Passwords don’t match');
      return;
    } else {
      setErrors('');

      setTimeout(() => {
        setErrors('');
      }, 5000);
    }

    try {
      const { user } = await firebase
        .auth()
        .createUserWithEmailAndPassword(email, password);
      const createHousehold = await db.collection('household').add({
        ownerUid: user.uid
      });
      const household = await createHousehold.get();
      await db
        .collection('users')
        .doc(user.uid)
        .set({
          email,
          householdUid: household.id
        });
      await firebase.auth().signInWithEmailAndPassword(email, password);
    } catch (error) {
      const { message } = error;
      setErrors(message);

      setTimeout(() => {
        setErrors('');
      }, 5000);
    }
  };

  const handleChange = e => {
    setValue({ ...value, [e.target.name]: e.target.value });
  };

  return (
    <>
      {user ? (
        <Redirect to="/" />
      ) : (
        <>
          <Header>Sign Up</Header>
          {errors && <Notification>{errors}</Notification>}
          <Form onSubmit={handleSubmit}>
            <FormGroup>
              <label>Email</label>
              <input
                type="email"
                name="email"
                onChange={e => handleChange(e)}
              />
            </FormGroup>
            <FormGroup>
              <label>Password</label>
              <input
                type="password"
                name="password"
                onChange={e => handleChange(e)}
              />
            </FormGroup>
            <FormGroup>
              <label>Repeat Password</label>
              <input
                type="password"
                name="passwordRepeat"
                onChange={e => handleChange(e)}
              />
            </FormGroup>
            <Button type="submit">Sign up</Button>
          </Form>
        </>
      )}
    </>
  );
}

const Header = styled.h2`
  font-family: sans-serif;
  margin-bottom: 30px;
`;

const Form = styled.form`
  font-family: sans-serif;
  background-color: var(--theme-primary-color);
  max-width: 100%;
  padding: 20px;
  border-radius: 24px;
  box-shadow: 0px 10px 20px rgba(0, 0, 0, 46%);
`;

const FormGroup = styled.div`
  margin-bottom: 20px;
  label,
  input {
    display: block;
  }

  label {
    font-weight: bold;
  }

  input {
    box-sizing: border-box;
    margin-top: 5px;
    width: 100%;
    padding: 10px;
    font-size: 1rem;
    border-radius: 8px;
    border: 1px solid var(--theme-secondary-color);
  }
`;

const Button = styled.button`
  display: block;
  width: 100%;
  padding: 20px;
  background-color: var(--theme-secondary-color);
  color: var(--theme-primary-color);
  font-size: 1.2rem;
  border-radius: 8px;
  border: 0;
`;
